__turbopack_context__.v({
  "list": "PeopleGrid-module-scss-module__u5smkW__list",
  "list-item": "PeopleGrid-module-scss-module__u5smkW__list-item",
});
